import { ApolloError, useQuery } from '@apollo/client'
import { COMPANIES_OF_RESPONSIBLE } from '../Queries'
import { FindCompaniesAndCountriesByResponsibleQueryVariables, FindCompaniesAndCountriesByResponsibleQuery } from '../../../types'

export default (): {
  data: FindCompaniesAndCountriesByResponsibleQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<
    FindCompaniesAndCountriesByResponsibleQuery,
    FindCompaniesAndCountriesByResponsibleQueryVariables
  >(COMPANIES_OF_RESPONSIBLE)

  return { data, error, loading }
}
